module.exports = __webpack_public_path__ + "static/img/TC.eff341d9.svg";